"use strict";
/**
 * Created by rouven on 21.03.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var redux_form_1 = require("redux-form");
// @ts-ignore
var query_string_1 = __importDefault(require("query-string"));
var types = __importStar(require("../actions/actionTypes"));
var submitStatus = __importStar(require("../constants"));
var initialEditState = function () { return ({
    rowId: null,
    colId: null,
    status: {},
    values: {},
    tmp: {}
}); };
var initialGridState = function () { return ({
    data: [],
    filter: {},
    pagination: {},
    selection: [],
    sort: null,
    edit: initialEditState()
}); };
var defaultFilter = {};
var gridReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case redux_form_1.actionTypes.INITIALIZE: {
            if (action.meta && action.meta.form && action.meta.form.indexOf('Filter') !== -1) {
                var gridState = Object.assign({}, state);
                var grid = action.meta.form.slice(0, action.meta.form.indexOf('Filter'));
                if (!gridState[grid]) {
                    gridState[grid] = initialGridState();
                }
                gridState[grid].filter = action.payload || {};
                return gridState;
            }
            return state;
        }
        case types.INITIALIZE: {
            var gridState = Object.assign({}, state);
            if (!gridState[action.name]) {
                gridState[action.name] = initialGridState();
            }
            return gridState;
        }
        case types.INITIALIZE_FILTER: {
            var gridState = Object.assign({}, state);
            defaultFilter[action.name] = action.initialValues || {};
            return gridState;
        }
        case types.DESTROY: {
            var gridState = Object.assign({}, state);
            if (gridState[action.name]) {
                delete gridState[action.name];
            }
            return gridState;
        }
        case types.LOCATION_CHANGED: {
            var gridState = Object.assign({}, state);
            var params = query_string_1["default"].parse(action.payload.search);
            var gridParams = params.grid ? JSON.parse(params.grid) : {};
            for (var grid in gridState) {
                if (!gridParams.hasOwnProperty(grid)) {
                    gridState[grid] = initialGridState();
                    gridState[grid].filter = defaultFilter[grid] || {};
                }
            }
            for (var grid in gridParams) {
                var gridConfig = gridParams[grid];
                if (!gridState[grid]) {
                    gridState[grid] = initialGridState();
                }
                gridState[grid].data = [];
                gridState[grid].selection = [];
                gridState[grid].pagination.pageSize = gridConfig.pageSize || null;
                gridState[grid].pagination.currentPage = gridConfig.currentPage || 1;
                gridState[grid].sort = gridConfig.sort || null;
                gridState[grid].filter = gridConfig.filter || Object.assign({}, gridState[grid].filter);
            }
            return gridState;
        }
        case types.DATA_CHANGED: {
            var gridState = Object.assign({}, state);
            if (!gridState[action.name]) {
                gridState[action.name] = initialGridState();
            }
            gridState[action.name].data = action.data;
            gridState[action.name].edit = initialEditState();
            return gridState;
        }
        case types.SELECTION_CHANGED: {
            var gridState = Object.assign({}, state);
            if (!gridState[action.name]) {
                gridState[action.name] = initialGridState();
            }
            var value_1 = [].concat(JSON.parse(action.value));
            var availableIds_1 = gridState[action.name].data.map(function (row) { return row.id; });
            value_1 = value_1.filter(function (v) { return availableIds_1.indexOf(v) !== -1; });
            if (action.checked) {
                gridState[action.name].selection = gridState[action.name].selection
                    .concat(value_1)
                    .filter(function (v, i, a) { return a.indexOf(v) === i; });
            }
            else {
                gridState[action.name].selection = gridState[action.name].selection
                    .filter(function (v) { return value_1.indexOf(v) === -1; });
            }
            return gridState;
        }
        case types.SELECTION_CLEARED: {
            var gridState = Object.assign({}, state);
            if (!gridState[action.name]) {
                gridState[action.name] = initialGridState();
            }
            gridState[action.name].selection = [];
            return gridState;
        }
        case types.EDIT_START: {
            var gridState = __assign({}, state);
            gridState[action.name].edit.rowId = action.rowId;
            gridState[action.name].edit.colId = action.colId;
            return gridState;
        }
        case redux_form_1.actionTypes.START_SUBMIT:
        case redux_form_1.actionTypes.SET_SUBMIT_SUCCEEDED:
        case redux_form_1.actionTypes.SET_SUBMIT_FAILED:
        case redux_form_1.actionTypes.CHANGE: {
            var gridState = __assign({}, state);
            var formName = action.meta && action.meta.form;
            var nameParts = formName.split('_');
            if (nameParts[0] === 'gridedit') {
                var name_1 = nameParts[1];
                var rowId = nameParts[2];
                var colId = nameParts[3];
                if (!gridState[name_1].edit.status[rowId]) {
                    gridState[name_1].edit.status[rowId] = {};
                }
                var status_1 = gridState[name_1].edit.status[rowId][colId];
                switch (action.type) {
                    case redux_form_1.actionTypes.START_SUBMIT:
                        status_1 = submitStatus.SUBMIT_STATUS_PENDING;
                        break;
                    case redux_form_1.actionTypes.SET_SUBMIT_SUCCEEDED:
                        status_1 = submitStatus.SUBMIT_STATUS_SUCCESS;
                        if (!gridState[name_1].edit.values[rowId]) {
                            gridState[name_1].edit.values[rowId] = {};
                        }
                        gridState[name_1].edit.values[rowId][colId] = gridState[name_1].edit.tmp
                            && gridState[name_1].edit.tmp[rowId]
                            && gridState[name_1].edit.tmp[rowId][colId];
                        break;
                    case redux_form_1.actionTypes.SET_SUBMIT_FAILED:
                        status_1 = submitStatus.SUBMIT_STATUS_FAILURE;
                        break;
                    case redux_form_1.actionTypes.CHANGE:
                        if (!gridState[name_1].edit.tmp[rowId]) {
                            gridState[name_1].edit.tmp[rowId] = {};
                        }
                        gridState[name_1].edit.tmp[rowId][colId] = action.payload;
                        break;
                }
                gridState[name_1].edit.status[rowId][colId] = status_1;
                return gridState;
            }
            return state;
        }
        default:
            return state;
    }
};
exports["default"] = gridReducer;
